import { Action } from 'redux';

import { ChangeRemoteExtractRefreshExpectedDuration } from '../../../bootstrap/redux/actions/AppActionTypes';
import { IRemoteRefreshScheduleInfo } from '../../models/IRemoteRefreshScheduleInfo';

export interface ChangeRemoteExtractRefreshExpectedDurationAction extends Action {
  scheduleInfo: IRemoteRefreshScheduleInfo;
}

export function changeRemoteExtractRefreshExpectedDuration(scheduleInfo: IRemoteRefreshScheduleInfo): ChangeRemoteExtractRefreshExpectedDurationAction {
  return {
    type: ChangeRemoteExtractRefreshExpectedDuration,
    scheduleInfo,
  };
}
